import { editMessage } from '$logic/message'
import { PendingEdit } from './types'
import { pendingEditsStorage } from './storage'

const processingPendingEdit = new Set<string>()

export async function deletePendingEdits(ids: string[]) {
  pendingEditsStorage.deleteMany(ids)
}

export async function createPendingEdits(messages: PendingEdit[]) {
  await pendingEditsStorage.insert(messages)
}

export async function handlePendingEdit(pendingEdit: PendingEdit) {
  await editMessage(pendingEdit)
  await deletePendingEdits([pendingEdit.id])
}

export async function syncPendingEdits() {
  await Promise.all(
    pendingEditsStorage.getAll().map(async pendingEdit => {
      if (processingPendingEdit.has(pendingEdit.id)) return
      handlePendingEdit(pendingEdit)
    }),
  )
}
